import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { POReceiptForm } from "@/components/purchasing/POReceiptForm";

export const POReceiveDialog = ({ po, onClose, items, onSaved }) => {
  const { t } = useLang();
  return (
    <Dialog open={!!po} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl" data-testid="po-receive-dialog">
        <DialogHeader><DialogTitle>{t("receive_po")} · <span className="font-mono">{po?.po_number}</span></DialogTitle></DialogHeader>
        {po && <POReceiptForm items={items} fixedPo={po} onCancel={onClose} onDone={() => { onClose(); onSaved(); }} />}
      </DialogContent>
    </Dialog>
  );
};
